/* eslint-disable */
/* Please refactor this file, I temporarily disabled lint on this file to remove the long warnings */
/* Warnings may cause errors or false positive bugs on javascript, lets avoid that */

import React, {Component} from 'react';
import Table from '../../../commons/Table/Table';
import Modal from '../../../commons/Modal/Modal';
import {InputField, DateField, SelectField, TagsInput, TextAreaField, Checkbox, MultipleInventoryField} from '../../../commons/Inputs';
import appConfig from '../../../../config';
import FloatingActionButton from '../../../commons/Buttons/FloatingActionButton';
import axios from 'axios';
import BillingStatement from './BillingStatement';
import Payments from './Payments';

let moment = window.moment;
let Bloodhound = window.Bloodhound;
let $ = window.$;
let inputmask = window.inputmask;

export default class TreatmentRecord extends Component {

	state = {
        patient_id : 0,
        user : null,

        treatment_id : 0,
        modalHeader : 'ADD NEW TREATMENT',
        paymentState : false,
        buttonState : 'Save',
        hideShowState : false,
        addTreatmentWithBillingId : 0,

        dataTable : [],
        branches : [],
        dentists : [],
		procedureItems : [],
        activeInventory : [],
        inventoryList : [{value : ''}],
        optionalLabel : 'Edit Inventory',
        // procedurePrice : [],

        headers : [
            {key : 'checkbox', label : ''},
            {key : 'date', label : 'Date'},
            {key : 'dentist', label : 'Dentist'},
            {key : 'branch', label : 'Branch'},
            {key : 'tooth_num', label : 'Tooth Number'},
            {key : 'surface', label : 'surface'},
            {key : 'proceduresParse', label : 'Procedure'},
            {key : 'remarks', label : 'Remarks'},
            {key : 'id', label : 'Id'} // for table sorting
        ],

        chartOptions: [],
        chartId : 0,

        surfaceOptions: [],
        priceDiscountType : [],
        checkedItems : [],
        checkedVatItem : [],
        dataItems : [],
        billingItem : [],
        total : 0,
        subTotal : 0,
        totalVat: 0,
        isSaving : false,
        count: 0,

        discountField : '',
        discountSelect : 'price',
        totalWIthoutDiscount : 0,

        dateInput : moment().format('MMMM DD, YYYY'),
        billingDate : moment().format('MMMM DD, YYYY'),
        dentistSelect : 0,
        facilitySelect : 0,
        surfaceInput : ['a','b'],
        quantityInput : '1',
        remarkTextArea : '',
        amountChargeInput : 0,
        toothNumbers : '',
        treatmentRender : true

    }

    getUser = () => {
        let user = this.props.user.toJS();
        
        this.setState({
            user,
            dentistSelect : user.role_info.id,
            facilitySelect : user.user_info.facility_id
        }); 
    }

    parseChartSelectData = (charts) => {
        
        let chartOptions = [
            {
                label: 'Select chart...',
                value: 0
            }
        ];

        for (let item of charts) {
            let tmp = {
                label: item.chart_name,
                value: item.id
            };

            chartOptions.push(tmp);
        }

        this.setState({
            chartOptions
        },() => {
            if (chartOptions.length > 1) {
                
                this.setState({
                    chartId: chartOptions[chartOptions.length - 1].value
                })
            }
        });
    }

    getCharts = () => {
        let url = `${appConfig.apiUrl}dental/patients/${this.state.patient_id}/chartings`;

        axios.get(url).then((res) => {
            this.parseChartSelectData(res.data.data);
        }).catch((error) => {
            console.log('Getting Charts Error: ',error);
        });
    }

    getActiveInventory = () => {
        let url = appConfig.apiUrl + 'management/dental/inventory/active';

        axios.get(url).then((res) => {
            this.setState({activeInventory : res.data.data});
        }).catch((error) => {
            console.log('Getting Charts Error: ',error);
        });
    }

    getProcedureList = () => {
        let url = appConfig.apiUrl + 'management/dental/procedures';

        axios.get(url).then((res) => {
            
            res.data.data.forEach((item, i) => {
                item['text'] = item.procedure;
                item['id'] = item.id.toString();
            })
            this.setState({
                procedureItems : res.data.data
            },() => {
                $('.select2-multiple-procedure').select2({
                    placeholder: 'Select procedure',
                    width: null,
                    tags : true,
                    data : this.state.procedureItems
                });
            });

        }).catch((error) => {
            console.log('Getting Charts Error: ',error);
        });
    }

    getDentists = () => {
        if (this.props.practitioners.get('data').size <= 0) {
            this.props.getPractitionersApi();
        }
    }

    getBranches = () => {
        if (this.props.branches.get('data').size <= 0) {
            this.props.getBranchesApi();
        }
    }

    parseBranches = (branchesRaw) => {
        let branches = [
            {
                value: 0,
                label: 'Select Clinic Branch...'
            }
        ];

        branchesRaw.forEach((item, i) => {
            let tmp = {
                value: item.id,
                label: item.name
            };

            branches.push(tmp);
        });

        return branches;
    }

    parseDentists = (dentistsRaw) => {
        let dentists = [
            {
                value: 0,
                label: 'Select Dentist...'
            }
        ];

        dentists = dentists.concat(dentistsRaw);

        return dentists;
    }

    getTreatmentRecordData = () => {
        App.blockUI({
            target: 'body',
            boxed: true
        });

        // try {
        //     $('#treatmentDataTable').dataTable().fnDestroy(); // reset dataTable
        // } catch(e) {
        //     console.log('treatment datatable not yet initialized');
        // }

        let url = appConfig.apiUrl + 'dental/patients/' + this.state.patient_id + '/treatments';
        
        axios.get(url).then((response) => {
            let tData = response.data.data;
            $('#treatmentDataTable').dataTable().fnDestroy(); // reset dataTable
            this.parseDataTable(tData);
            
            this.setState({
                dataTable : tData,
                treatmentRender : true
            }, () => {
                
                setTimeout(() => {
                    $('#treatmentDataTable').DataTable({
                        'autoWidth': true,
                        'iDisplayLength': 5,
                        'lengthMenu' : [ 5, 10, 20, 50, 100 ],
                        'language' : {
                            "emptyTable" : 'No Treatment Records Available'
                        },
                        retrieve: true,
                        'columnDefs': [
                            {
                                'targets': [8], // id last column
                                'visible': false,
                                'searchable': false
                            }
                        ],
                        // autoWidth : true,
                        'order': [[8,'DESC']]
                    });
                },500)
                

            });

            App.unblockUI('body');
            
        }).catch((error) => { 
            console.log(error)
            App.unblockUI('body');
        })
    }

    closeModal = () => {
        this.resetTreatmentModalForm();
    }

    closeBottomModal = () => {
        $('.bottomModal').hide(100);
    }

    onCheck = (e,data) => {
        let selectedBox = $('input[name=tNamebox]:checked');
        
        let objData = this.state.dataItems;
        let count = objData.length;
        let index = $(objData).index($(e.target));

        if(e.target.checked) // true 
        {
            $('.bottomModal').show(100);
            objData.push(data);
            count = objData.length;
        }else
        {
            objData.splice(index,1);
            count = objData.length;
            
            if(count == 0)
            {
                $('.bottomModal').hide(100);
            }else{
                $('.bottomModal').show(100);
            }
            
        }

        // if(count > 0)
        // {
        //     objData.splice(index,1);
        //     count = objData.length;
        // }
        
        this.setState({
            count,
            dataItems : objData
        },() => {
            console.log(this.state.dataItems);
        });
    }

    onCheckVat = (e) => {
        // EXCLUSIVE VAT

        let vat = 0.12; // 12 % vat
        let subTotal = this.state.subTotal; // computed price
        let total_vat = subTotal * vat / (1 + vat); // computed vat value
        let total = 0;

        if(e.target.checked)
        {
            
            total = subTotal / (1 + vat); // FORMULA = price / (1 + vat)
            
            this.setState({
                total : Math.round(total),
                totalWIthoutDiscount : Math.round(total),
                totalVat : Math.round(total_vat * 100) / 100,
                discountField : ''

            });

            return;
        }

        total = subTotal;

        if($('input[name=seniorDiscount]').is(':checked')) // uncheck senior vat
        {
            $('input[name=seniorDiscount]').click();
        }

        this.setState({
            total : total,
            totalWIthoutDiscount : total,
            totalVat : 0,
            discountField : ''

        });
    }

    onCheckSeniorDiscount = (e) => {

        let vat = 0.12; // 12 % vat
        let seniorVat = 0.20; // senior vat 20%
        let subTotal = this.state.subTotal; // computed price
        let total_vat = subTotal * vat / (1 + vat); // computed vat value
        let total = 0;

        if(e.target.checked)
        {
            
            total = subTotal - total_vat; // compute total price with vat
            total = total / (1 + seniorVat) // FORMULA = price / (1 + senior vat)

            this.setState({
                total : Math.round(total),
                totalWIthoutDiscount : Math.round(total),
                totalVat : Math.round(total_vat),
                checkedVatItem : {vatBox:'vatBox'},
                discountField : ''

            });

            return;
        }

        total = subTotal;

        $('input[name=vatBox]').click(); // uncheck vat box

        this.setState({
            total : total,
            totalWIthoutDiscount : total,
            totalVat : 0,
            checkedVatItem : [],
            discountField : ''

        });
    }

    onChangeDiscount = (e) => {
        let discountType = $('#priceDiscount').val();
        let total = this.state.total;
        let val = e.target.value;

        if(!$('input[name=vatBox]').is(':checked'))
        {
            total = this.state.subTotal;
        }

        if(discountType == 'price')
        {
            total = total - val;
            this.setState({
                total : total,
                discountField : e.target.value
            });
            return;
        }

        total = total - (total * (val / 100)); // percent computation
        this.setState({
            total : Math.round(total),
            discountField : e.target.value
        });
    }

    saveMakeBilling = () => {

        this.setState({
            isSaving : true
        });

        let url = appConfig.apiUrl + 'dental/billing/' + this.state.patient_id;

        let vat_discount = $('input[name=vatBox]').is(':checked') ? 1 : 0;
        let senior_discount = $('input[name=seniorDiscount]').is(':checked') ? 1 : 0;
        let discount_type = this.state.discountSelect;
        let discount = this.state.discountField;
        let procedures = this.state.dataItems;
        
        procedures.map((item, i) => { // remove html object
            item.for_billing = 1; // set item for billing
            delete item['checkbox'];
        });

        let data = {
            vat_discount: vat_discount,
            senior_discount : senior_discount,
            discount_type : discount_type,
            discount : discount,
            treatment_records : procedures,
            date: this.state.billingDate
        };
        
        axios.post(url,data).then((response) => {
            let tData = response.data.data;
            console.log(tData);
            this.setState({
                billingItem : tData,
                isSaving : false,
                count: 0,
                dataItems : []
            }, () => {
                $('.bottomModal').hide(100);
                $('#makeBillingModal').modal('hide');
                $('a[href="#billingStatementListContent"]').click();
            });
            
        }).catch((error) => { 
            console.log(error);
        })
    }

    nextToInventory = (e) => {
        let hideShow = true;
        let treatmentId = this.state.treatment_id;
        let modalTitle = 'Edit Inventory';
        let optionalLabel = $(e.target).text();
        
        if(optionalLabel == 'Edit Inventory')
        {
            $('#treatmentRecordModal').modal().css({'width': '540px','margin-left': function () {return -($(this).width() / 2);}})
            optionalLabel = 'Back';
        }else{
            $('#treatmentRecordModal').modal().css({'width': '1080px','margin-left': function () {return -($(this).width() / 2);}})
            optionalLabel = 'Edit Inventory';
            hideShow = false;
            if(treatmentId == 0){
                modalTitle = 'Add new Treatment';
            }else{
                modalTitle = 'Edit Treatment';
            }
        }

        // $('#inventoryModal').modal('show');
        this.setState({
            hideShowState : hideShow,
            buttonState : 'Save',
            modalHeader : modalTitle,
            optionalLabel : optionalLabel
        });

    }

    saveTreatment = () => {

        this.setState({
            isSaving : true
        });
        
        // let formData = $('#inventoryForm').serializeArray();
        // $("#inventoryForm").find(":input").appendTo("#treatmentForm");
        let treatmentForm = $('#treatmentForm');
        let inventoryForm = $('#inventoryForm');
        let datas = treatmentForm.serializeArray();
        let inventoryData = inventoryForm.serializeArray();

        inventoryData.forEach((item, i) => {
            datas.push(item);
        })
        // console.log(datas);return;
        let url = appConfig.apiUrl + 'dental/treatments';

        datas.push({name:'patient_id',value:this.state.patient_id});
        datas.push({name:'billingId',value:this.state.addTreatmentWithBillingId});
        // datas.push({name : 'inventory', value: formData});

        datas.map((item, i) => { // parse data
            if(item['name'] == 'practitionerId')
            {
                item['name'] = 'practitioner_id';
            }

            if(item['name'] == 'facilityId')
            {
                item['name'] = 'facility_id';
            }
            if(item['name'] == 'tooth_numbers')
            {
                item['value'] = $('#toothNumbersId').val();
            }

            if(item['name'] == 'surface')
            {
                item['value'] = $('#surfaceInputs').val();
            }

            if(item['name'] == 'procedures')
            {
                item['value'] = $('#procedures').val();
            }
        });

        if(this.state.treatment_id != 0) // EDIT STATE
        {
            url = appConfig.apiUrl + 'dental/treatments/' + this.state.treatment_id;
            datas.push({name: '_method', value: 'PUT'});
            // console.log($.param(datas),datas)
            axios.put(url,$.param(datas)).then((response) => {
                // console.log(response);
                // reset datatable
                $('#treatmentDataTable').dataTable().fnDestroy();

                let datas = response.data.data;
                let dataTable = this.state.dataTable;

                this.parseDataTable(datas);

                // edit element of array
                dataTable.forEach((item, i) => {

                    if(item.id == datas[0].id)
                    {
                        dataTable[i] = datas[0];
                    }
                });
                
                this.setState({
                    isSaving : false,
                    count : 0, // reset count
                    dataItems : [], // reset selected treatment
                    dataTable
                },() => {
                
                    $('#treatmentDataTable').DataTable({
                        'autoWidth': true,
                        'iDisplayLength': 5,
                        'columnDefs': [
                            {
                                'targets': [8], // id last column
                                'visible': false,
                                'searchable': false
                            }
                        ],
                        'columnDefs': [
                            {
                                'targets': [8], // id last column
                                'visible': false,
                                'searchable': false
                            }
                        ],
                        'order': [[8,'DESC']]
                    });
                    
                    this.resetTreatmentModalForm(); // reset

                    $('.bottomModal').hide(100);
                });

                $('#treatmentRecordModal').modal('hide');
                $('#inventoryModal').modal('hide');

            }).catch((error) => {
                console.log(error);
                this.setState({
                    isSaving : false
                });
            });

            return;
        }

        axios.post(url,$.param(datas)).then((response) => {
            // console.log(response);return;
            // reset datatable
            $('#treatmentDataTable').dataTable().fnDestroy();

            let datas = response.data.data;
            let dataTable = this.state.dataTable;
            
            this.parseDataTable(datas);

            //  add elements to the beginning of an array
            dataTable.unshift(datas[0]);
            
            this.setState({
                isSaving : false,
                dataTable
            },() => {
                $('#treatmentDataTable').DataTable({
                    'autoWidth': true,
                    'iDisplayLength': 5,
                    'columnDefs': [
                        {
                            'targets': [8], // id last column
                            'visible': false,
                            'searchable': false
                        }
                    ],
                    'columnDefs': [
                        {
                            'targets': [8], // id last column
                            'visible': false,
                            'searchable': false
                        }
                    ],
                    'order': [[8,'DESC']]
                });

                this.resetTreatmentModalForm(); // reset
            });

            $('#treatmentRecordModal').modal('hide');
            $('#inventoryModal').modal('hide');

        }).catch((error) => {
            console.log(error);
        });
    }

    clickAddTreatment = () => {

        this.resetTreatmentModalForm();

        $('#treatmentRecordModal').modal('show');
    }

    resetTreatmentModalForm = () => {
        let user = this.props.user.toJS();

        this.setState({
            dateInput : moment().format('MMMM DD, YYYY'),
            treatment_id : 0,
            remarkTextArea : '',
            toothNumbers : '',
            amountChargeInput : '',
            surfaceInput : [],
            modalHeader : 'ADD NEW TREATMENT',
            inventoryList : [{value : ''}],
            hideShowState : false,
            buttonState : 'Save',
            quantityInput : '1',
            dentistSelect : user.role_info.id,
            facilitySelect : user.user_info.facility_id,
            addTreatmentWithBillingId : 0
            // procedurePrice : []
        },() => {
            // $('#procedures').tagsinput('removeAll');
            $('.select2-multiple-tooth').select2('val', []);
            $('.select2-multiple-surface').select2('val', []);
            $('.select2-multiple-procedure').select2('val', []);
        });
    }

    handlerOnProceed = () => {
        let createdData = this.state.dataItems;
        let subTotal = 0;

        createdData.map((item, i) => { // compute total for all selected procedure
            subTotal += item.amount;

            if(createdData[0].practitioner_id !== item.practitioner_id)
            {
                //alert('may kakaiba' + item.dentist)
                App.blockUI({
                    message: 'Different dentists were selected. Click to continue.',
                    zIndex: 99999,
                    boxed: true
                })
                $('.blockOverlay').on('click', () => {
                    App.unblockUI();
                });

            }
        });

        this.setState({
            total : subTotal,
            totalWIthoutDiscount : subTotal,
            subTotal : subTotal,
            totalVat : 0
        });

        $('#makeBillingModal').modal('show');
    }

    handlerOnEdit = (e) => {
        
        let id = e.target.dataset.id;

        let objData = this.state.dataTable;
        let index = objData.findIndex((item) => item.id == id);

        let createdData = objData[index];
        let date = moment().format('MMMM DD, YYYY');
        let remarks = '';
        let dentistSelect = 0;
        let facility = 0;
        let tooth = '';
        
        if(typeof id === 'undefined') // if checbox is clicked
        {
            return;
        }

        if(createdData.for_billing == 1) // for billing is not editable
        {
            return;
        }

            date = moment(createdData.date).format('MMMM DD, YYYY');
            remarks = createdData.remarks;
            dentistSelect = createdData.practitioner_id;
            facility = (createdData.facility_id ? createdData.facility_id : 0);
        
        let proData = []

        createdData.procedures.forEach((pro, j) => {
            proData.push(pro.id)
            // $('#procedures').tagsinput('add',{id : pro.id, procedure : pro.procedure, price : pro.price});
        });
            
        this.setState({
            dateInput : date,
            treatment_id : createdData.id,
            remarkTextArea : remarks,
            dentistSelect : dentistSelect,
            facilitySelect : facility,
            toothNumbers : createdData.tooth_num.split(','),
            amountChargeInput : createdData.amount,
            surfaceInput : createdData.surface.split(','),
            modalHeader : 'EDIT TREATMENT',
            // procedurePrice : new Array(createdData.procedures),
            quantityInput : createdData.quantity
        },() => {
            $('#treatmentRecordModal').modal('show'); 
            $('.select2-multiple-tooth').select2('val', this.state.toothNumbers);            
            $('.select2-multiple-surface').select2('val', this.state.surfaceInput);            
            $('.select2-multiple-procedure').select2('val', proData);   
                 
        });
    }

    handlerOnDelete = () => {
        let data = this.state.dataItems;
        let dataTable = this.state.dataTable;
        let ids = [];
        
        let url = appConfig.apiUrl + 'dental/treatments/0';

        data.forEach((item, i) => {
            
            ids.push(item.id);
            
            dataTable.forEach((list, j) => {
                if(item.id == list.id)
                {
                    dataTable.splice(j , 1);
                }
            });
        });

        
        let datas = {'ids' : ids,'_method' : 'delete'};
        
        axios.post(url,datas).then((response) => {
            // console.log(response)
            // reset datatable
            $('#treatmentDataTable').dataTable().fnDestroy();

            this.setState({
                dataItems : [],
                count : 0,
                dataTable : dataTable
            },() => {
                
                $('.bottomModal').hide(100);
                
                $('#treatmentDataTable').DataTable({
                    'autoWidth': true,
                    'iDisplayLength': 5,
                    'columnDefs': [
                        {
                            'targets': [8], // id last column
                            'visible': false,
                            'searchable': true
                        }
                    ],
                    'columnDefs': [
                        {
                            'targets': [8], // id last column
                            'visible': false,
                            'searchable': false
                        }
                    ],
                    'order': [[8,'DESC']]
                });

                $('#deleteConfirmationModal').modal('hide');

            });
            
        }).catch((error) => { 
            console.log(error);
        })


    }

    parseDataTable = (data) => {
        
        data.map((row, i) => {
            let proceduresRow = '';
            let createdId = 'tBox' + row.id;

            row.procedures.map((item, i) => {
                proceduresRow += item.procedure + ', ';
            });
            row.proceduresParse = proceduresRow;
            row.dentist = row.dentist.replace('DR.','Dr.');
            let facility_name = row.branch;
            row.facility = {name : facility_name};
            if(row.for_billing == 0)
            {
                row.checkbox = <Checkbox name="tNamebox" id={createdId} label="" value={row.id} dataRow={row} key={i} index={i} onchange={this.onCheck} checkedItems={this.state.checkedItems} />
            }

        });
    }

    handleOnVoid = (data) => {
        
        let dataTable = this.state.dataTable;

        for(let row of dataTable)
        {
            for(let item of data)
            {
                if(item.id == row.id)
                {
                    row.for_billing = 0;
                }
            }
        }
        // console.log(dataTable);return;
        // dataTable.forEach((row, i) => {
        //     data.forEach((item, j) => {
        //         if(item.id == row.id)
        //         {
        //             row.for_billing = 0;

        //         }
        //     })
        // });
       
        this.parseDataTable(dataTable);
        
        $('#treatmentDataTable').dataTable().fnDestroy(); // reset dataTable

        this.setState({
            dataTable, 
            paymentState : true
        },() => {
                
            setTimeout(() => {
                $('#treatmentDataTable').DataTable({
                    'autoWidth': true,
                    'iDisplayLength': 5,
                    'lengthMenu' : [ 5, 10, 20, 50, 100 ],
                    'language' : {
                        "emptyTable" : 'No Treatment Records Available'
                    },
                    retrieve: true,
                    'columnDefs': [
                        {
                            'targets': [8], // id last column
                            'visible': false,
                            'searchable': false
                        }
                    ],
                    // autoWidth : true,
                    'order': [[8,'DESC']]
                });
            },500)
        });
    }

    onPaymentSaved = () => {
        this.setState({paymentState : true});
    }

    handleChangeDiscount = (e) => {
        let total = this.state.totalWIthoutDiscount
        
        this.setState({ 
            discountSelect: e.target.value,
            discountField: '',
            total 
        })
    }

    onTagsAdded = (item) => {
        let amount = Number(this.state.amountChargeInput) + Number(item.price);
        // let proPrice = this.state.procedurePrice;
        // if(typeof proPrice[0] !== 'undefined')
        // {
        //     proPrice[0].push(item);
        // }

        this.setState({
            amountChargeInput : amount
            // procedurePrice : proPrice
        });
    }

    onTagsRemove = (item) => {
        let id = item.id;
        // let proPrice = this.state.procedurePrice;
        // let index = proPrice[0].findIndex((item) => item.id == id);
        //     proPrice[0].splice(index, 1);
        
        let amount = Number(this.state.amountChargeInput) - Number(item.price);
        
        if(amount < 0)
        {
            amount = 0;
        }
        
        this.setState({
            amountChargeInput : amount
            // procedurePrice : proPrice
        });
    }

    onChangeQty = (e)=> {
        let qty = e.target.value;
        let charge = this.state.amountChargeInput;
        // let procedures = this.state.procedurePrice;
        
        // let price = 0;

        // procedures.forEach((item, i) => {
        //     price += Number(item.price);
        // });

        // if(qty == '' || qty == 0)
        // {
        //     qty = 1;
        //     // return;
        // }

        let amount = Number(qty) * charge; 

        this.setState({
            quantityInput : qty
            // amountChargeInput : amount
        }) 
    }

    onCheckInventory = (e,data) => {
        console.log(data);
    }

    onAddedItem = (index) => {
        let inventoryList = this.state.inventoryList;
        inventoryList.push({value : ''});
        
        this.setState({inventoryList}, () => {
            // console.log(inventoryList)
        });
    }

    onDeleteItem = (index) => {
        let inventoryList = this.state.inventoryList;
        
        inventoryList.splice(index, 1);
        this.setState({inventoryList},() => {
            // console.log(inventoryList)
        });
    }

    saveTreatmentRecord = () => {
        // validation
        if($('#price').val() == '' || $('#price').val() < 0)
        {
            $('#price').focus();
            return;
        }
        if(this.state.quantityInput == 0 || this.state.quantityInput == '')
        {
            $('#quantity').focus();
            return;
        }
        if(this.state.dentistSelect == 0)
        {
            $('#practitionerId').focus();
            return;
        }
        this.saveTreatment();
        
    }

    updateValue = (val, index) => {
        let inventoryList = this.state.inventoryList;
        inventoryList[index] = {value : val};
        
        this.setState({inventoryList : inventoryList});
    }

    addNewTreatmentFromBilling = (billData) => {

        this.resetTreatmentModalForm();

        let billingId = billData.id;
        this.setState({
            addTreatmentWithBillingId : billingId
        },() => {
            // console.log(this.state);
            $('#treatmentRecordModal').modal('show');
        });
    }

    componentWillMount() {
        this.getActiveInventory();
        this.getBranches();
        this.getDentists();
        this.getProcedureList();

        this.setState({
            patient_id : this.props.storeParams.patientId
        },() => {
            this.getUser();
            this.getCharts();
        });

        this.setState({
            surfaceOptions: [
                {text: 'none', id: 'None'},
                {text: 'all', id: 'All Surface'},
                {text: 'labial', id: 'Labial'},
                {text: 'mesial', id: 'mesial'},
                {text: 'incisal', id: 'Incisal'},
                {text: 'distal', id: 'Distal'},
                {text: 'palatal', id: 'Palatal'},
                {text: 'occlusal', id: 'Occlusal'},
                {text: 'buccal', id: 'Buccal'},
                {text: 'cervical', id: 'Cervical'},
                {text: 'lingual', id: 'Lingual'}
            ],
            priceDiscountType : [
                {value : 'price', label: 'Price Discount'},
                {value : 'percent', label: '% Discount'}
            ]
        });

        // var procedureItems = new Bloodhound({
        //        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        //        queryTokenizer: Bloodhound.tokenizers.whitespace,
        //        remote: {
        //            url: `${appConfig.apiUrl}management/dental/procedures?q=%QUERY`,

        //            wildcard: '%QUERY'
        //        }
        //    });

    }

    componentDidMount() {

        $('#makeBillingModal').submit(false); // return submit form

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {

            let target = e.target.href.split('#');
            let index = target.findIndex((item) => {
                return item === 'treatmentPage'
            });

            if (index >= 0 && this.state.treatmentRender) {
                this.getCharts();
                this.getTreatmentRecordData();
            }
        });



        $.fn.select2.defaults.set("theme", "bootstrap");

        $('.select2-multiple-tooth').select2({
            placeholder: 'Select Tooth Numbers',
            maximumInputLength : 2,
            width: null
        });

        $('.select2-multiple-surface').select2({
            placeholder: 'Select surface',
            width: null,
            data : this.state.surfaceOptions
        });

        $('.select2-multiple-procedure').on('select2:select', (evt) => {
            let item = evt.params.data;

            let amount = Number(this.state.amountChargeInput) + Number(item.price);

            this.setState({
                amountChargeInput : amount
            });
        });

        $('.select2-multiple-procedure').on('select2:unselect', (evt) => {
            let item = evt.params.data;

            let amount = Number(this.state.amountChargeInput) - Number(item.price);

            this.setState({
                amountChargeInput : amount
            });
        });

        $('#price').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            // digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            min : 0,
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99, //max val on api DECIMAL(8, 2)
            oncomplete : (e) => {
                // this.setState({
                //     amountChargeInput: e.target.value
                // });
            },
            oncleared : (e) => {
                // this.setState({
                //     amountChargeInput: 0
                // });
            }
        });

        $('#discount').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99 //max val on api DECIMAL(8, 2)
        });

        // $('#treatmentRecordModal').on('hidden.bs.modal', () => { // reset treatment form when modal is close
        //     this.resetTreatmentModalForm();
        // });

    }

    componentWillReceiveProps(nextProps) {
        // console.log('props to treatment record', nextProps);

        if(nextProps.refreshFromCharting) {
            this.setState({treatmentRender : true});
            this.getTreatmentRecordData();
        }



    }

	render() {
        const { practitioners, branches } = this.props;
        let dentistsOptions = this.parseDentists(practitioners.get('data').toJS());
        let branchesOptions = this.parseBranches(branches.get('data').toJS());

        let dataSelected = this.state.dataItems;
        let dentistSelect = this.state.dentistSelect;
        let inventory = this.state.activeInventory;
        let inventoryList = this.state.inventoryList;
        
		return (
			<div className="row" style={{position: 'relative'}}>
                <div className="col-md-12 text-center">

                    <ul className="nav nav-pills nav-justified treatmentMenuNav" style={{display: 'inline-block',marginTop : '10px'}}>
                        <li className="active">
                            <a href="#treatmentListContent" data-toggle="tab" aria-expanded="true"> Treatment List </a>
                        </li>
                        <li className="">
                            <a href="#billingStatementListContent" data-toggle="tab" aria-expanded="false" onClick={this.closeBottomModal}> Billing Statement </a>
                        </li>
                        <li className="">
                            <a href="#paymentContent" data-toggle="tab" aria-expanded="false" onClick={this.closeBottomModal}> Payments </a>
                        </li>
                    </ul>

                </div>
                <div className="col-md-12">
                    <div className="tab-content">
                        <div className="tab-pane fade active in" id="treatmentListContent">

                            <Table headers={this.state.headers} data={this.state.dataTable} rowClick={this.handlerOnEdit} id="treatmentDataTable" />

                        </div>

                        <div className="tab-pane fade" id="billingStatementListContent">

                            <BillingStatement
                                data={this.state.billingItem}
                                patient_id={this.state.patient_id}
                                branches={branchesOptions}
                                onVoid={this.handleOnVoid}
                                onChangeState={this.onPaymentSaved}
                                onAddNewTreatment={this.addNewTreatmentFromBilling}
                                billingUpdateId={this.state.addTreatmentWithBillingId}
                            />

                        </div>

                        <div className="tab-pane fade" id="paymentContent">

                            <Payments patient_id={this.state.patient_id} onChangeState={this.state.paymentState} />

                        </div>
                    </div>
                </div>

                <Modal
                    id="treatmentRecordModal"
                    header={this.state.modalHeader}
                    onNegativeClickEvent={this.closeModal}
                    onPositiveClickEvent={this.saveTreatmentRecord}
                    positiveButton={this.state.buttonState}
                    onOptionalButtonClickEvent={this.nextToInventory}
                    isSaving={this.state.isSaving}
                    optionalButton={this.state.optionalLabel}
                    width="1080">

                    <div className="row" style={{display : !this.state.hideShowState ? 'block' : 'none'}}>

                        <form id="treatmentForm" onSubmit={(e) => { return false; }}>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <DateField val={this.state.dateInput} id="date" label="Date" help="input date" onChange={ (e) => {this.setState({dateInput : e.target.value})} }/>
                                    </div>
                                    <div className="col-md-6">
                                        <SelectField val={this.state.chartId} id="dental_chart_id" label="Chart Name" help="Select Chart" options={this.state.chartOptions} onChange={(e) => {this.setState({chartId : e.target.value})}} multiple={false} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <SelectField val={dentistSelect} id="practitionerId" label="Designate Dentist" help="Select Dentist" options={dentistsOptions} onChange={(e) => {this.setState({dentistSelect : e.target.value})}} multiple={false} />
                                    </div>
                                    <div className="col-md-6">
                                        <SelectField val={this.state.facilitySelect} id="facilityId" label="Designate Clinic" help="Select Dentist" options={branchesOptions} onChange={(e) => {this.setState({facilitySelect : e.target.value})}} multiple={false} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group form-md-line-input">
                                            <select id="surfaceInputs" className="form-control select2-multiple-surface" name="surface" multiple>
                                                {/*this.state.surfaceOptions.map((item, i) => {
                                                 return <option key={i} value={item.value}>{item.label}</option>
                                                 })*/}
                                            </select>
                                            <label htmlFor="surfaceInputs">Surface</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <InputField val={this.state.quantityInput} id="quantity" label="Quantity" help="Quantity" type="number" onChange={this.onChangeQty} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <TextAreaField val={this.state.remarkTextArea} id="remarks" label="Remarks" help="Remarks" onChange={(e) => {this.setState({remarkTextArea : e.target.value})}} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    {/*<div className="col-md-12">
                                     <TagsInput val="" id="procedures" label="Procedure" help="Input Procedure" typeahead={true} dataItems={this.state.procedureItems} nameClass="tagsTypeaheadProcedure" onItemAdded={this.onTagsAdded} onItemRemove={this.onTagsRemove} />

                                     </div>*/}

                                    <div className="col-md-12">
                                        <div className="form-group form-md-line-input">
                                            <select id="procedures" className="form-control select2-multiple-procedure" name="procedures" multiple>

                                            </select>
                                            <label htmlFor="surfaceInputs">Procedure</label>
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{marginTop: '-15px'}}>
                                        <div className="form-group form-md-line-input">
                                            <select id="toothNumbersId" className="form-control select2-multiple-tooth" name="tooth_numbers" multiple>
                                                <optgroup label="Adult">
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                    <option value="13">13</option>
                                                    <option value="14">14</option>
                                                    <option value="15">15</option>
                                                    <option value="16">16</option>
                                                    <option value="17">17</option>
                                                    <option value="18">18</option>
                                                    <option value="21">21</option>
                                                    <option value="22">22</option>
                                                    <option value="23">23</option>
                                                    <option value="24">24</option>
                                                    <option value="25">25</option>
                                                    <option value="26">26</option>
                                                    <option value="27">27</option>
                                                    <option value="28">28</option>
                                                    <option value="31">31</option>
                                                    <option value="32">32</option>
                                                    <option value="33">33</option>
                                                    <option value="34">34</option>
                                                    <option value="35">35</option>
                                                    <option value="36">36</option>
                                                    <option value="37">37</option>
                                                    <option value="38">38</option>
                                                    <option value="41">41</option>
                                                    <option value="42">42</option>
                                                    <option value="43">43</option>
                                                    <option value="44">44</option>
                                                    <option value="45">45</option>
                                                    <option value="46">46</option>
                                                    <option value="47">47</option>
                                                    <option value="48">48</option>
                                                </optgroup>
                                                <optgroup label="Child">
                                                    <option value="51">51</option>
                                                    <option value="52">52</option>
                                                    <option value="53">53</option>
                                                    <option value="54">54</option>
                                                    <option value="55">55</option>
                                                    <option value="61">61</option>
                                                    <option value="62">62</option>
                                                    <option value="63">63</option>
                                                    <option value="64">64</option>
                                                    <option value="65">65</option>
                                                    <option value="71">71</option>
                                                    <option value="72">72</option>
                                                    <option value="73">73</option>
                                                    <option value="74">74</option>
                                                    <option value="75">75</option>
                                                    <option value="81">81</option>
                                                    <option value="82">82</option>
                                                    <option value="83">83</option>
                                                    <option value="84">84</option>
                                                    <option value="85">85</option>
                                                </optgroup>
                                            </select>
                                            <label htmlFor="toothNumbersId">Tooth No.</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <InputField val={this.state.amountChargeInput} id="price" label="Amount Charge" help="Charge" type="text" onChange={() => {this.setState({amountChargeInput : e.target.value})}} />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="row">

                        <form id="inventoryForm" onSubmit={(e) => { return false; }} style={{minHeight : '300px',display : this.state.hideShowState ? 'block' : 'none'}}>

                            <div className="col-md-12">
                                <h4><strong>Inventory</strong></h4>
                                {inventoryList.map((item, i) => {
                                    return <MultipleInventoryField key={i} index={i} data={inventory}
                                                                   val={item.value} totalIndex={inventoryList.length}
                                                                   itemId={"inventory[" +i+ "][inventory_id]"}
                                                                   quantityId={"inventory[" +i+ "][quantity]"}
                                                                   onAddedItem={this.onAddedItem}
                                                                   onDeleteItem={this.onDeleteItem}
                                                                   updateValue={this.updateValue} />
                                })}
                            </div>

                        </form>
                    </div>
                </Modal>



                <div className="bottomModal" style={{display: 'none'}}>
                    <div className="container-fluid">
                        <button type="button" className="close" aria-hidden="true" onClick={this.closeBottomModal}></button>
                    </div>
                    <div className="container-fluid">
                        <div className="col-md-4">
                            <span className="badge badge-default">{this.state.count}</span> Selected items
                        </div>
                        <div className="col-md-4">
                            <button className="btn btn-xs green" onClick={this.handlerOnProceed} style={{marginRight : '10px'}}>
                                <i className="fa fa-check"></i>Create Billing Statement
                            </button>
                        </div>
                        <div className="col-md-4">
                            <a className="red" data-toggle="modal" data-target="#deleteConfirmationModal" style={{color: 'red'}}>
                                <strong>Delete Selected</strong>
                            </a>
                        </div>
                    </div>
                </div>

                <Modal
                    id="makeBillingModal"
                    header="Create Billing Statement"
                    onNegativeClickEvent={this.closeModal}
                    onPositiveClickEvent={this.saveMakeBilling}
                    isSaving={this.state.isSaving}
                    width="640">

                    <div className="row">
                        <div className="col-md-12">
                            <form id="makeBillingForm" className="form-horizontal">
                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table table-hover table-striped table-light">
                                            <tbody>
                                            {dataSelected.map((item, i) => {
                                                return <tr key={i}>
                                                    <td>{item.proceduresParse}</td>
                                                    <td className="text-right">{parseFloat(item.amount).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                                </tr>
                                            })}
                                            <tr style={{borderBottom : '1px solid #F2F5F8'}}>
                                                <td>
                                                    <Checkbox name="vatBox" id="vatId" label="Value Added Tax Exemption" value="vatBox" key="0" index="0" onchange={this.onCheckVat} checkedItems={this.state.checkedVatItem} />
                                                </td>
                                                <td className="text-right">{parseFloat(this.state.totalVat).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</td>
                                            </tr>
                                            <tr style={{borderBottom : '1px solid #F2F5F8'}}>
                                                <td>
                                                    <Checkbox name="seniorDiscount" id="seniorId" label="Senior Citizen Discount" value="seniorDiscount" key="0" index="0" onchange={this.onCheckSeniorDiscount} checkedItems={[]} />
                                                </td>
                                                <td></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="container-fluid">
                                        <div className="col-md-5">
                                            <span className="help-block">Billing Date</span>
                                        </div>
                                        <div className="col-md-5 col-md-offset-2">
                                            <DateField val={this.state.billingDate} id="billing_date"
                                                       label="" help="input billing date"
                                                       onChange={ (e) => {this.setState({billingDate : e.target.value})} }/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="container-fluid">
                                        <div className="col-md-5">
                                            {/*<SelectField val={this.state.discountSelect} id="priceDiscount" label="" help="" options={this.state.priceDiscountType} multiple={false} />*/}
                                            <div className="form-group form-md-line-input">
                                                <select id="priceDiscount" name="discount_type" className="form-control" value={this.state.discountSelect}
                                                        onChange={this.handleChangeDiscount}
                                                >

                                                    {this.state.priceDiscountType.map((item, i) => {
                                                        return (
                                                            <option value={item.value} key={i}>{item.label}</option>
                                                        )
                                                    })}
                                                </select>
                                                <label htmlFor="priceDiscount"></label>
                                                <span className="help-block">Select Discount Type</span>
                                            </div>
                                        </div>
                                        <div className="col-md-5 col-md-offset-2">

                                            <div className="form-group form-md-line-input">
                                                <input type="text" className="form-control" id="discount"
                                                       name="discount"
                                                       onBlur={this.onChangeDiscount}
                                                       onChange={(e) => {this.setState({discountField : e.target.value})}}
                                                       value={this.state.discountField} />

                                                <label htmlFor="discount"></label>
                                                <span className="help-block">Discount</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="container-fluid">
                                        <div className="col-md-6" style={{borderBottom : '1px solid #F2F5F8'}}>
                                            <label><strong>Total</strong></label>
                                        </div>
                                        <div className="col-md-6 text-right" style={{borderBottom : '1px solid #F2F5F8'}}>
                                            <label><strong>{parseFloat(this.state.total).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}</strong></label>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </Modal>

                <Modal
                    id="deleteConfirmationModal"
                    header="DELETE"
                    onNegativeClickEvent={this.closeModal}
                    onPositiveClickEvent={this.handlerOnDelete}
                    positiveButton="Delete"
                    isSaving={this.state.isSaving}
                    width="640">

                    <div className="container">
                        <p>Are you sure do you want to delete?</p>
                    </div>
                </Modal>

                <FloatingActionButton
                    title="Add new treatment"
                    onClick={this.clickAddTreatment} />

            </div>
		)
	}

}



/** WEBPACK FOOTER **
 ** ./src/components/patient/Treatment_record/TreatmentRecord.js
 **/